import { put, call, takeLatest } from 'redux-saga/effects';
import * as api from './Api';
import { push } from 'react-router-redux';
import { actions } from './Reducer';
import {
  setArtisanPublicInquiryIsLoading,
  getArtisanPublicInquirySuccessAction,
  addArtisanPublicInquirySuccessAction,
  deleteArtisanPublicInquirySuccessAction,
  editArtisanPublicInquirySuccessAction,
  getArtisanPublicInquiriesSuccessAction,
  setArtisanPublicInquiryCount,
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../../notifications/Actions';

function* getArtisanPublicInquiry({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setArtisanPublicInquiryIsLoading(true));
    const response = yield call(api.getArtisanPublicInquiry, body);
    const { data } = response;
    yield put(getArtisanPublicInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Get Public Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPublicInquiryIsLoading(false));
  }
}

const searchData = {
  offset: 0,
  size: 10,
  searchTerm: '',
  filterBy: [],
  // filterCustomerID: customerId,
  filterArtisanID: '',
  sort: 'createdAt',
  dir: 'asc',
};

function* getArtisanPublicInquiries({ payload }) {
  const body = { ...payload, ...searchData };
  try {
    yield put(setArtisanPublicInquiryIsLoading(true));
    const response = yield call(api.getArtisanPublicInquiries, body);
    const { data } = response;
    const { content, count } = data;
    yield put(getArtisanPublicInquiriesSuccessAction(content));
    yield put(setArtisanPublicInquiryCount(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPublicInquiryIsLoading(false));
  }
}

function* deleteArtisanPublicInquiry({ payload }) {
  const id = payload;
  try {
    yield put(setArtisanPublicInquiryIsLoading(true));
    yield call(api.deleteArtisanPublicInquiry, id);
    yield put(deleteArtisanPublicInquirySuccessAction(id));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPublicInquiryIsLoading(false));
  }
}

function* editArtisanPublicInquiry({ payload: { id, body }, trusted }) {
  try {
    yield put(setArtisanPublicInquiryIsLoading(true));
    if (trusted) {
      const response = yield call(
        api.editArtisanPublicInquiryTrusted,
        id,
        body
      );
      const { data } = response;
      yield put(editArtisanPublicInquirySuccessAction(data));
      yield put(newSuccessNotificationAction('Inquiry Edited'));
      yield put(push('/customer-public-inquiry-artisan/'));
    } else {
    const response = yield call(api.editArtisanPublicInquiry, id, body);
    const { data } = response;
    // yield put(editArtisanPublicInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Inquiry Edited Pending'));
    yield put(push('/customer-public-inquiry-artisan/'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPublicInquiryIsLoading(false));
  }
}

function* addArtisanPublicInquiry({ payload, trusted }) {
  try {
    yield put(setArtisanPublicInquiryIsLoading(true));
    if (trusted) {
      const response = yield call(api.addArtisanPublicInquiryTrusted, payload);
      const { data } = response;

      yield put(addArtisanPublicInquirySuccessAction(data));
      yield put(push('/customer-public-inquiry-artisan/'));
      yield put(newSuccessNotificationAction('Inquiry Added'));
    } else {
      const response = yield call(api.addArtisanPublicInquiry, payload);
      const { data } = response;
      yield put(push('/customer-public-inquiry-artisan/'));
      yield put(newSuccessNotificationAction('Inquiry Added Pending!'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanPublicInquiryIsLoading(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_ARTISAN_PUBLIC_INQUIREY,
    getArtisanPublicInquiry
  );
  yield takeLatest(
    actions.GET_ARTISAN_PUBLIC_INQUIRIES,
    getArtisanPublicInquiries
  );
  yield takeLatest(
    actions.DELETE_PUBLIC_ARTISAN_INQUIRY,
    deleteArtisanPublicInquiry
  );
  yield takeLatest(actions.ADD_PUBLIC_ARTISAN_INQUIRY, addArtisanPublicInquiry);
  yield takeLatest(
    actions.EDIT_PUBLIC_ARTISAN_INQUIRY,
    editArtisanPublicInquiry
  );
}
